import { Button, Message, Drawer, Space } from '@bedrock/components';
import { Upload } from '@bedrock/icons-react';
import React, { useState, useRef, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import HeatingBoostUpload from "@mpc/common/src/features/HeatingBoost/HeatingBoostUpload";
import { ResponseListOutsourceBoostEffectDetailDto, outsourceDemandBatchUpsertBoostEffectData, outsourceDemandQueryBoostEffectData } from 'services/api';

type Props = {
    initBoostNum?: number,
    onChange?: (data: any) => void,
    detail?: any
}

const Index = (props: Props) => {
    const { initBoostNum, onChange, detail } = props;
    const [boostButtonLoading, setBoostButtonLoading] = useState(false)
    const [boostTableList, setBoostTableList] = useState<any>([])
    const [boostVisible, setBoostVisible] = useState(false)
    const [boostNum, setBoostNum] = useState<undefined | number>(undefined)
    const boostRef = useRef<any>(null)
    const handleChangeData = (value: number | undefined) => {
        typeof onChange === 'function' && onChange(value)
    }

    useEffect(() => {
        setBoostNum(initBoostNum)
        handleChangeData(initBoostNum)
    }, [initBoostNum])

    useUpdateEffect(() => {
        handleChangeData(boostNum)
    }, [boostNum])

    const handleClose = () => {
        setBoostVisible(false)
        boostRef?.current.form?.resetFields()
    }

    const handleBoostSubmit = async () => {
        const data = await boostRef?.current.validateFields()
        const boost_effect_datas = [...boostTableList].map(item => {
            return {
                ...item,
                boost_cost: item?.boost_cost?.value,
                boost_cost_currency: detail?.quote_currency || detail?.demand_advertising?.dspf_offer_currency || detail?.budgetCurrency
            }
        })
        if (boostTableList?.length) {
            setBoostButtonLoading(true)
            outsourceDemandBatchUpsertBoostEffectData({ boost_effect_datas }).then((result: any) => {
                setBoostVisible(false)
                setBoostNum(boost_effect_datas?.length)
                Message.success('操作成功')
            }).finally(() => {
                setBoostButtonLoading(false)
            })
        }
    }

    const handleUploadBoost = () => {
        outsourceDemandQueryBoostEffectData({ demand_id: detail?.id }).then((result: ResponseListOutsourceBoostEffectDetailDto) => {
            const boostTableList = result.data?.map((item: any) => {
                return {
                    ...item,
                    boost_cost: {
                        value: item?.boost_cost,
                        currency: detail?.quote_currency || detail?.demand_advertising?.dspf_offer_currency || detail?.budgetCurrency
                    }
                }
            }) as any
            setBoostVisible(true)
            setBoostTableList(boostTableList)
        })
    }
    return (
        <div style={{ display: 'flex' }} className='items-center'>
            <Button type='checked'icon={<Upload />} onClick={handleUploadBoost}>上传加热助推效果</Button>
            <div style={{ margin: '0px 16px' }}>
                (已上传<b style={{ margin: '0px 4px' }}>{boostNum || 0}</b>条)
            </div>
            <Drawer
                maskClosable={false}
                title='上传加热助推效果'
                visible={boostVisible}
                onClose={handleClose}
                destroyOnClose
                zIndex={1000}
                height={'100vh'}
                placement="bottom"
                bodyStyle={{ paddingTop: 0, paddingBottom: 0 }}
                footer={
                    <Space direction="vertical" align="end">
                      <Space size={12}>
                        <Button type="checked-neutral" onClick={handleClose} loading={boostButtonLoading}>取消</Button>
                        <Button
                          type="primary"
                          onClick={() => handleBoostSubmit()}
                          loading={boostButtonLoading}
                        >
                          提交
                        </Button>
                      </Space>
                    </Space>
                }
            >
                <HeatingBoostUpload
                    value={boostTableList}
                    onChange={e => {
                        const boostTableList = e?.map(item => {
                            return {
                                ...item,
                                demand_id: detail?.id,
                                demand_type: 'MPC_DEMAND',
                                boost_cost: {
                                    value: item?.boost_cost?.value,
                                    currency: detail?.quote_currency
                                }
                            }
                        })
                        setBoostTableList(boostTableList)
                    }} ref={boostRef} />
            </Drawer>
        </div>
    )
}

export default Index;